export default __webpack_public_path__ + "7e323674c33b3939aba542e22c95c6d3.woff2";